import {useEffect} from "react";

export const useTitle = (newTitle) => {
    useEffect(()=>{
        const old = document.title;
        document.title = newTitle;
        return () => {
            document.title = old;
        }
    }, [newTitle])
}
